import { render, staticRenderFns } from "./land-table.vue?vue&type=template&id=3534d97c&scoped=true"
import script from "./land-table.vue?vue&type=script&lang=js"
export * from "./land-table.vue?vue&type=script&lang=js"
import style0 from "./land-table.vue?vue&type=style&index=0&id=3534d97c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3534d97c",
  null
  
)

export default component.exports